import * as angular from 'angular';
import { DistanceToGradComponent } from './distance-to-grad.component';

export const DistanceToGradModule = angular
  .module('distanceToGrad', [])
  .component('distanceToGradComponent', DistanceToGradComponent).name;
